import React, { useEffect, useRef } from 'react';
import { StyledTimelineTabs } from './StyledTimelineTabs';
import PropTypes from "prop-types";
import {gsap} from 'gsap'


const TimelineTabs = ({ active, handleClick, percTimer, arrayYears }) => {
  const tabs = useRef(null)
  useEffect(() => {
    const selected = document.querySelector('.selected.num')
    const rectRight = selected.getBoundingClientRect().right;
    
    if(rectRight > tabs.current.clientWidth){
      gsap.to(tabs.current,{x: tabs.current.parentNode.clientWidth - rectRight, duration: .5})
    }else{
      gsap.set(tabs.current, {x: 0})
    }

  }, [active]);

  return (
    <React.Fragment>
      {
        <StyledTimelineTabs >
          <div className="slider-tabs"  ref={tabs}>
          {
            arrayYears.map((key, i) => {
              return <div key={i} className={active === i ? 'selected num' : 'num'}  onClick={(e) => handleClick(e, i)}>
                <p className="preset-12">{key.year}</p>
                <span className="tab--line" style={{width: `${active === i ? percTimer : 0 }%`}}></span>
              </div>
            })
          }
          </div>
          
        </StyledTimelineTabs>
          
      }
    </React.Fragment>
  );
};

TimelineTabs.propTypes = {
  active: PropTypes.number,
};

TimelineTabs.defaultProps = {
  tag: "div",
  active: 0
};

export default TimelineTabs;
